var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91016 23.8472V27.1527H11.2157V23.8472H7.91016Z",
    fill: "#DE007A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8672 23.8472V27.1527H16.1727V23.8472H12.8672Z",
    fill: "#DE007A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8281 23.8472V27.1527H21.1337V23.8472H17.8281Z",
    fill: "#DE007A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8281 19.6738V22.9794H21.1337V19.6738H17.8281Z",
    fill: "#DE007A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8672 19.6738V22.9794H16.1727V19.6738H12.8672Z",
    fill: "#DE007A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91016 19.6738V22.9794H11.2157V19.6738H7.91016Z",
    fill: "#DE007A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7852 19.6738V22.9794H26.0907V19.6738H22.7852Z",
    fill: "#DE007A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7852 15.5835V18.8891H26.0907V15.5835H22.7852Z",
    fill: "#DE007A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8281 15.5835V18.8891H21.1337V15.5835H17.8281Z",
    fill: "#DE007A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8672 15.5835V18.8891H16.1727V15.5835H12.8672Z",
    fill: "#DE007A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9 5.75682H27.4125V3.1875H24.4375V5.75682H9.5625V3.1875H6.5875V5.75682H5.1C3.46375 5.75682 2.125 6.91301 2.125 8.32614V28.8807C2.125 30.2938 3.46375 31.45 5.1 31.45H28.9C30.5362 31.45 31.875 30.2938 31.875 28.8807V8.32614C31.875 6.91301 30.5362 5.75682 28.9 5.75682ZM28.9 28.8807H5.1V14.7494H28.9V28.8807ZM28.9 12.1801H5.1V8.32614H28.9V12.1801Z",
    fill: "#DE007A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.255d96472ff0647802df62abd43d4a00.svg";
export { ForwardRef as ReactComponent };